'use strict';

import angular from 'angular';

const limit = 6;

export default function recentBookingsFactory($q, $http, $stateParams, utils, currencyModel) {
  'ngInject';

  return {
    fetch: function () {
      const placeId = $stateParams.placeId;
      const requestParams = {
        limit: limit,
        offset: this.list && this.list.length || 0,
        placeId: placeId,
        currency: currencyModel.getValue()
      };

      this.isFetching = true;

      return new $q((resolve, reject) => {
        $http.get(utils.getApiUrl('intro/recent_bookings'), { params: requestParams })
          .then((response) => {
            const responseData = response.data;
            let bookings = responseData.bookings;


            this.list = this.list || [];

            if (!this.list.length && bookings.length && placeId && bookings[0].guide.location.placeId !== placeId) {
              bookings = [];
            }

            if (bookings.length) {
              this.hasMore = responseData.hasMore;
              angular.forEach(bookings, booking => this.list.push(booking));
            }

            resolve(bookings);
          })
          .catch(reject)
          .finally(() => {
            delete this.isFetching;
          });
      });
    },

    reset: function () {
      this.list = [];
      this.hasMore = false;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/common/recent_bookings/recent_bookings.service.js